<template>
  <div class="task-volunteers">
    <ag-table :data-source-api="getAllTaskVolunteers" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" />
  </div>
</template>

<script>
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';

const tasksRepo = RepositoryFactory.get('tasksRepository');

export default {
  name: "TaskVolunteers",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      gender: {
        male: 'ذكر',
        female: 'انثى',
      },
      taskVolunteersIsApplied: {
        'true': 'نعم',
        'false': 'لا',
      },
      taskVolunteersIsCouponApplied: {
        'true': 'نعم',
        'false': 'لا',
      },
      permissions: {
        // add: 'tasks_management',
        // edit: 'tasks_management',
        // delete: 'tasks_management',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'معرف المتطوع',
          field: 'id',
          sortable: true,
          suppressSizeToFit: true,
          width: 200,
        },
        {
          headerName: 'الاسم',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'رقم الموبايل',
          field: 'phoneNumber',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'المجموعة',
          field: 'volunteerInfo.groupName',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'الجنس',
          field: 'volunteerInfo.gender',
          width: 210,
          sortable: false,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.values(self.gender),
          }
        },
        {
          headerName: 'الصف',
          field: 'volunteerInfo.studyYear',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'تم القبول من المتطوع',
          field: 'taskSessionVolunteers.isConfirmed',
          width: 210,
          sortable: false,
          valueGetter:
            function getObject(data) {
              if (!data.data.taskSessionVolunteers) return '-';
              if (!data.data.taskSessionVolunteers[0]) return '-';
              return data.data.taskSessionVolunteers[0].isConfirmed ? 'نعم' : 'لا';
            },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.taskVolunteersIsApplied),
            valueFormatter: params => {
              return self.taskVolunteersIsApplied[params.value];
            }
          }
        },
        {
          headerName: 'تم تطبيق الكوبون',
          field: 'taskSessionVolunteers.isCouponApplied',
          width: 210,
          sortable: false,
          valueGetter:
            function getObject(data) {
              if (!data.data.taskSessionVolunteers) return '-';
              if (!data.data.taskSessionVolunteers[0]) return '-';
              return data.data.taskSessionVolunteers[0].isCouponApplied ? 'نعم' : 'لا';
            },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.taskVolunteersIsCouponApplied),
            valueFormatter: params => {
              return self.taskVolunteersIsCouponApplied[params.value];
            }
          }
        },
      ];
    },
    async getAllTaskVolunteers(query) {
      const id = this.$route.params.id;
      return await tasksRepo.getTaskVolunteers(id, query);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
